/**
 * CRUD operations — universal across all permission systems
 */
export enum CrudOperation {
  READ = 'read',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

/**
 * Generic permission scope helper.
 * Each portal defines its own Subject enum and passes it here.
 *
 * @example
 * type EmployeePermissionScope = PermissionScopeOf<EmployeeSubject>;
 */
export type PermissionScopeOf<S extends string> = `${S}.${CrudOperation}`;
